import { Loader } from 'src/common/components/Loader';
import { SuccessIcon } from 'src/common/images/SuccessCheckIcon';
import { ProcessState } from 'src/pages/VerificationPage/components/VerificationPageFlow/VerificationPageSuccessPageFlow.styled';
import { ReactComponent as ErrorCheckSvg } from 'src/assets/icons/error-check.svg';
import styled, { css } from 'styled-components';

const Heading = styled.h4<{
  error?: boolean;
  isLoading?: boolean;
}>`
  font-weight: ${({ isLoading }) => (isLoading ? 500 : 400)};
  font-size: 1rem;
  line-height: 1rem;
  color: ${({ theme }) => theme.text.primary};
  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.dangerBorder};
      font-weight: 600;
    `}
`;

interface ProcessingStepProps {
  text: string;
  isLoading?: boolean;
  isError?: boolean;
  isSuccess?: boolean;
}

export const VerificationPageProcessingStep = ({
  text,
  isLoading,
  isError,
  isSuccess,
}: ProcessingStepProps) => {
  const renderIcon = () => {
    if (isLoading) {
      return <Loader />;
    }

    if (isError) {
      return <ErrorCheckSvg />;
    }
    if (isSuccess) {
      return <SuccessIcon />;
    }

    return null;
  };

  return (
    <ProcessState>
      {renderIcon()}
      <Heading isLoading={isLoading} error={isError}>
        {text}
      </Heading>
    </ProcessState>
  );
};
